import { render, staticRenderFns } from "./odetail.vue?vue&type=template&id=fcf68f24&scoped=true"
import script from "./odetail.vue?vue&type=script&lang=js"
export * from "./odetail.vue?vue&type=script&lang=js"
import style0 from "./odetail.vue?vue&type=style&index=0&id=fcf68f24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf68f24",
  null
  
)

export default component.exports